





































































import { Component, Vue } from 'vue-property-decorator'

import { PAGE_TITLE } from './constant-config'
import { setSelectedCity, deleteQueryStringKey , isHzwApp , goBackNative} from '@utils/index'

import { namespace } from 'vuex-class'
const cityChooseModule = namespace('cityChoose')

import LocalStorageSet from './LocalStorageSet'

interface City {
  ID: string
  NAME: string
  PINYIN: string
  provinceID: string
}
function push(target: any, k: any, v: any) {
  target[k] = target[k] || []
  target[k].push(v)
}

function groupBy(list: any[], key: any, proc: (n: any) => any) {
  const res = {}
  list.forEach((o) => {
    const k = proc ? proc(o[key]) : o[key]
    if (!k) {
      throw new Error('')
    }
    push(res, k, o)
  })
  return res
}

@Component({
  components: {},
})
export default class CityChoose extends Vue {
  keyword = ''
  hasFocus = false
  showCityList: any = {}
  history: any[] = []
  hotCitys: any[] = []
  refererUrl: string | (string | null)[] = ''

  @cityChooseModule.State cmsAppConfig!: any
  @cityChooseModule.State cityList!: any[]
  @cityChooseModule.Action getAppConfigAction!: () => Promise<any>
  @cityChooseModule.Action getCityListAction!: () => Promise<any>

  mounted() {
    this.fetchCityList()
    this.history = this.city().getAll()
  }

  async created() {
    this.$setTitle(PAGE_TITLE)
    this.$tracker('128', '121012982')()
    this.refererUrl = this.$route.query.referer || ''
  }

  inputFocus() {
    this.$newClickTracker({ bizType: '128', pageLevelId: '121012982', clickId: '200002' })
    this.hasFocus = true
  }

  get cityKeys() {
    return Object.keys(this.showCityList).sort()
  }

  get showDeleteHistory() {
    return this.history.length > 0
  }

  async fetchCityList() {
    //本地读取一个ls对象
    const ls_update_time = this.ls_update_time()
    const ls_citylist = this.ls_citylist()
    const ls_hotCitys = this.ls_hotCitys()

    if (!this.cmsAppConfig) {
      await this.getAppConfigAction()
    }

    //获取热门城市列表配置
    const appConfig = this.cmsAppConfig
    // 请求过来的更新时间
    const res_update_time = appConfig.cities_update_time
    // 接口读取过来的热门城市数组
    const res_hotCitys = appConfig.hotaddress
    // 上次保存的更新时间
    const update_time = ls_update_time.read()[0] ? ls_update_time.read()[0] : 0
    // 从本地读取城市列表
    let data: any[] = ls_citylist.read()
    let hotCitys = ls_hotCitys.read()
    // 判断1.本地读取的城市列表为空，或者 2.更新时间大于上次保存时间
    if (hotCitys.length === 0 || data.length === 0 || new Date(update_time).getTime() < new Date(res_update_time).getTime()) {
      // 清空本地存储对象数据
      ls_citylist.clear()
      ls_update_time.clear()
      ls_hotCitys.clear()
      const _hotCitys: any[] = []
      ////获取所有已开通的城市列表
      await this.getCityListAction()

      const cityList: any[] = this.cityList
      cityList.forEach((item) => {
        ls_citylist.push(item)
        // 判断从接口读取过来热门城市在城市列表中是否存在，存在就加入到hotCitys中
        if (res_hotCitys.indexOf(item.NAME) >= 0) {
          _hotCitys.push(item)
          ls_hotCitys.push(item)
        }
      })
      data = ls_citylist.read()
      hotCitys = _hotCitys
      ls_update_time.push(res_update_time)
    }
    this.hotCitys = hotCitys
    const reg = /[a-z]/g
    data.forEach((item) => {
      // console.log(item.PINYIN.replace(reg, ''))
      item.PY = item.PINYIN.replace(reg, '')
    })
    this.showCityList = groupBy(data, 'PINYIN', (s) => s[0].toUpperCase())
  }

  noop() {
    console.log('noop')
  }
  search() {
    console.log('search')
  }
  anchor(char: string) {
    return `#${char}`
  }
  toggleCity() {
    let decodeRefUrl = this.getRefererUrl()
    location.replace(decodeRefUrl)
  }

  scrollTo(char: string) {
    if (this.hasFocus) {
      return
    }
    const el = document.getElementById(char)
    if (el) {
      const offset = el.offsetTop
      const scroll = offset - this.fixedHeight()
      window.scrollTo(0, scroll)
    }
  }

  fixedHeight() {
    const header = (this.$refs.header as HTMLElement).offsetHeight
    const search = (this.$refs.search as HTMLElement).offsetHeight
    return this.hasFocus ? search : header + search
  }

  useHotCity(city: City) {
    this.$newClickTracker({ bizType: '128', pageLevelId: '121012982', clickId: '200001', positionParam: { citycode: city.ID, name: city.NAME } })
    this.useCity(city)
  }

  useCity(city: City) {
    console.error(city)

    this.city().unshift(city)

    let decodeRefUrl = this.getRefererUrl()

    setSelectedCity(city.ID, city.NAME, decodeRefUrl)

    if(this.$route.query.autoClose){
       if(isHzwApp()){
         goBackNative()
       }else {
         history.back()
       }
       return
    }

    // let tempUrl = deleteQueryStringKey(decodeRefUrl, 'swt')
    // let _url = tempUrl + (tempUrl.indexOf('?') !==-1 ? '&' : '?') + `swt=1`
    // timestamp 解决 安卓微信浏览器中location.href后次进入点击失效的问题
    let tempUrl = deleteQueryStringKey(decodeRefUrl, 'timestamp')
    let _url = tempUrl + (tempUrl.indexOf('?') !== -1 ? '&' : '?') + 'timestamp=' + new Date().getTime()
    
    console.info('last _url', _url)
    location.href = _url
  }

  getRefererUrl() {
    let refUrl = ''
    if (typeof this.refererUrl == 'string') {
      refUrl = this.refererUrl as string | ''
    } else if (typeof this.refererUrl == 'object') {
      refUrl = (this.refererUrl as string[])[this.refererUrl.length - 1]
    }
    console.info('last refererUrl', refUrl)
    refUrl = refUrl ? refUrl : '//life.cekid.com/h5/home'
    let decodeRefUrl = decodeURIComponent(refUrl)
    console.info('last refererUrl decoded', decodeRefUrl)
    return decodeRefUrl
  }

  city() {
    return new LocalStorageSet('cache.city', 6, 'ID')
  }

  clearCity() {
    this.history = []
    new LocalStorageSet('cache.city', 6, 'ID').clear()
  }

  ls_citylist() {
    return new LocalStorageSet('cache.showCitylist', 1000, 'ID')
  }

  ls_update_time() {
    return new LocalStorageSet('cache.update_time', 1)
  }

  ls_hotCitys() {
    return new LocalStorageSet('cache.hotCitys', 10)
  }

  filterCities(list: any[]) {
    const needle = this.keyword.toUpperCase()
    return list.filter((item) => item.PINYIN.toUpperCase().indexOf(needle) !== -1 || item.PY.indexOf(needle) !== -1 || item.NAME.indexOf(needle) !== -1)
  }
}
